import { IIdentifiable } from '../models/core/identifiable.interface';

export class ArrayHelper {
    public static RemoveElementFromArray<T extends IIdentifiable>(elements: T[], elementId: number | string): T[] {
        elements.forEach((element, index) => {
            if (element.id === elementId) {
                elements.splice(index, 1);
            }
        });

        return elements;
    }

    /**
     * Compare deux liste de string et indique si elles sont egale
     * @param s1 Liste 1
     * @param s2 Liste 2
     * @returns Retourne vrai ou faux
     */
    public static arrayIsEqual(s1: string[], s2: string[]): boolean {
        if (!!s1 && !!s2) {
            return s1.sort((a, b) => a.localeCompare(b)).toString() == s2.sort((a, b) => a.localeCompare(b)).toString();
        } else {
            return false;
        }
    }

    /**
     * Crée une copie immutable d'un tableau (ne possède pas la même reference)
     * @param array : Tableau à copier.
     * @returns : Une copie du tableau.
     */
    public static createImmutableCopy(array: any[]) {
        return [].concat(array);
    }
}
